export default __webpack_public_path__ + "locales/sk/Files.json?hash=2dcf2a052d5efaf699276c39d864a4ec";